import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function NotFoundPage() {
  return (
    <section className="relative flex min-h-[72vh] items-center overflow-hidden">
      <div aria-hidden className="pointer-events-none absolute inset-0 grid-overlay opacity-60" />
      <div aria-hidden className="pointer-events-none absolute left-1/4 top-10 h-[380px] w-[380px] rounded-full bg-emerald/10 blur-[120px]" />
      <div className="container-wide relative z-10 grid items-end gap-10 py-20 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <span className="eyebrow">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald" /> Error 404 — page not found
          </span>
          <h1 className="mt-7 font-display text-7xl font-bold leading-[0.9] tracking-tight text-cloud sm:text-9xl">
            <span className="text-gradient">404</span>
          </h1>
          <p className="mt-6 max-w-md font-sans text-base leading-relaxed text-muted">
            The page you're looking for has either been moved or never existed.
            Head back to the homepage.
          </p>
        </div>
        <div className="lg:col-span-4 flex gap-3">
          <Link to="/" className="btn-primary" data-testid="404-back-home">
            <ArrowLeft className="h-4 w-4" /> Back home
          </Link>
          <Link to="/apply" className="btn-secondary">
            Apply now <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
